import React from 'react';
import {connect} from 'react-redux';

import MeterDataBlock from './MeterDataBlock';

const MeterDataBlockComponent = ({data, context, transactionData}) => {
  return <MeterDataBlock data={data} context={context} transactionData={transactionData} />;
};

const mapStateToProps = (state) => {
  return {
    transactionData: state.cellcomTransactionSummary.transactionData,
  };
};

export default connect(mapStateToProps, null)(MeterDataBlockComponent);
